<template>
  <div class="footer-links">
    <AccordionGroup>
      <Accordion disable-desktop title="Help">
        <ul class="link-group">
          <li>
            <Button tag="a" href="/pages/returns" form="underline-invert"
              >Returns &amp; Refunds</Button
            >
          </li>
          <li>
            <Button
              tag="a"
              href="/pages/help?category=my-orders"
              form="underline-invert"
              >Orders</Button
            >
          </li>
          <li>
            <Button
              tag="a"
              href="/pages/help?category=rewards"
              form="underline-invert"
              >Rewards</Button
            >
          </li>
          <li>
            <Button
              tag="a"
              href="/pages/help?category=delivery"
              form="underline-invert"
            >
              Shipping &amp; Delivery
            </Button>
          </li>
          <li>
            <Button
              tag="a"
              href="/pages/help?category=technical"
              form="underline-invert"
              >Technical</Button
            >
          </li>
          <li>
            <Button tag="a" href="/pages/returns-portal" form="underline-invert"
              >Start A Return</Button
            >
          </li>
          <li>
            <Button
              tag="a"
              href="/pages/rat-and-boa-atelier-service"
              form="underline-invert"
              >Atelier Service</Button
            >
          </li>
        </ul>
      </Accordion>
      <Accordion disable-desktop title="Contact Us">
        <ul class="link-group">
          <li>
            <Button
              tag="a"
              form="underline-invert"
              href="https://wa.me/447418613960"
            >
              Chat on whatsapp
            </Button>
            <TimeSensitiveWrapper>
              <sup class="available">Available</sup>
            </TimeSensitiveWrapper>
          </li>
          <li>
            <Button id="live-chat" tag="a" form="underline-invert">
              Live chat
            </Button>
            <TimeSensitiveWrapper>
              <sup class="available">Available</sup>
            </TimeSensitiveWrapper>
          </li>
          <li>
            <Button
              tag="a"
              href="mailto:customercare@ratandboa.com"
              form="underline-invert"
              >Email</Button
            >
          </li>
        </ul>
      </Accordion>
      <Accordion disable-desktop title="Company">
        <ul class="link-group">
          <li>
            <Button tag="a" href="/pages/sustainability" form="underline-invert"
              >Sustainability</Button
            >
          </li>
          <li>
            <Button
              tag="a"
              href="/pages/sustainability-report-2023"
              form="underline-invert"
              >Sustainability Report 2023</Button
            >
          </li>
        </ul>
      </Accordion>
      <Accordion disable-desktop title="Follow Us">
        <ul class="link-group">
          <li>
            <Button
              tag="a"
              target="_blank"
              href="https://www.instagram.com/ratandboa"
              form="underline-invert"
              >Instagram</Button
            >
          </li>
          <li>
            <Button
              tag="a"
              target="_blank"
              href="https://www.tiktok.com/@ratandboa"
              form="underline-invert"
              >Tiktok</Button
            >
          </li>
        </ul>
      </Accordion>
    </AccordionGroup>
  </div>
</template>

<script>
import AccordionGroup from "@/components/AccordionGroup.vue";
import Accordion from "@/components/AccordionV2.vue";
import Button from "@/components/ButtonV2.vue";
import TimeSensitiveWrapper from "@/components/TimeSensitiveWrapper.vue";

export default {
  name: "FooterLinks",
  components: {
    Accordion,
    AccordionGroup,
    Button,
    TimeSensitiveWrapper,
  },
};
</script>

<style lang="scss" scoped>
.footer-links {
  padding: 40px 20px;

  @include respond-above(md) {
    padding-top: 30px;
    max-width: 1440px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
  }
}

:deep(.accordion__header) {
  @include editorial-body(16px);

  @include respond-above(md) {
    border-top: none;
    @include editorial-body(20px);
  }
}

.link-group {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 20px;

  @include respond-above(md) {
    gap: 12px;
  }

  li {
    display: flex;
  }

  :deep(.button) {
    font-size: 12px;
  }

  .available {
    margin-left: 4px;
    color: $color-green;
    @include utility-label(10px);
  }
}
</style>
